import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CssVariableSnippetComponent } from '../../../../shared/components/css-variable-snippet/css-variable-snippet.component';
import { StylingCardShellComponent } from '../styling-card-shell/styling-card-shell.component';

@Component({
    selector: 'avd-background-color-card',
    standalone: true,
    templateUrl: './background-color-card.component.html',
    styleUrls: ['./background-color-card.component.scss'],
    imports: [StylingCardShellComponent, CssVariableSnippetComponent],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BackgroundColorCardComponent {
    @Input() cssVariable: string = '';
    @Input() label: string = '';

    get cssVariableName(): string {
        return this.cssVariable.trim();
    }

    get swatchBackgroundColor(): string {
        if (!this.cssVariableName) {
            return 'transparent';
        }

        return `var(${this.cssVariableName})`;
    }

    get cssVariableSnippet(): string {
        return this.cssVariableName;
    }
}
